(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-banner"]) return;
  try {
    
  (function () {
    var SYNODIC = 29.53058867;
    var KNOWN_NEW_MS = Date.UTC(2000, 0, 6, 18, 14, 0);
    var PHASES = [
      { max: 1.84566, name: 'New Moon' },
      { max: 5.53699, name: 'Waxing Crescent' },
      { max: 9.22831, name: 'First Quarter' },
      { max: 12.91963, name: 'Waxing Gibbous' },
      { max: 16.61096, name: 'Full Moon' },
      { max: 20.30228, name: 'Waning Gibbous' },
      { max: 23.99361, name: 'Last Quarter' },
      { max: 27.68493, name: 'Waning Crescent' },
      { max: 29.53059, name: 'New Moon' }
    ];
    var now = new Date();
    var noon = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
    var age = ((noon - KNOWN_NEW_MS) / 86400000) % SYNODIC;
    if (age < 0) age += SYNODIC;
    var name = PHASES[PHASES.length - 1].name;
    var i;
    for (i = 0; i < PHASES.length; i += 1) {
      if (age < PHASES[i].max) {
        name = PHASES[i].name;
        break;
      }
    }
    document.querySelectorAll('.footer-banner [data-moon-phase]').forEach(function (el) {
      if (el.getAttribute('data-moon-phase') === name) {
        el.classList.add('footer-banner__moon--today');
        el.setAttribute('title', name);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function bindNavDropdowns() {
    document.querySelectorAll('[data-nav-dropdown]').forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      var trigger = root.querySelector('[data-nav-dropdown-trigger]');
      var panel = root.querySelector('[data-nav-dropdown-panel]');
      if (!trigger || !panel) return;
      var mode = root.getAttribute('data-nav-mode') || 'hover';
      var accordion = mode === 'accordion';
      var closeTimer = 0;

      var cancelClose = function () {
        window.clearTimeout(closeTimer);
      };

      var open = function () {
        cancelClose();
        document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (other) {
          if (other === root) return;
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('[data-nav-dropdown-trigger]');
          var otherPanel = other.querySelector('[data-nav-dropdown-panel]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      };

      var close = function () {
        root.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      };

      var scheduleClose = function () {
        cancelClose();
        closeTimer = window.setTimeout(close, 120);
      };

      if (!accordion) {
        root.addEventListener('mouseenter', open);
        root.addEventListener('mouseleave', scheduleClose);
      }
      trigger.addEventListener('click', function (event) {
        if (
          !accordion &&
          window.matchMedia('(hover: hover) and (pointer: fine)').matches
        ) {
          return;
        }
        event.preventDefault();
        if (panel.hidden) open();
        else close();
      });
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (panel.hidden) open();
          else close();
        }
        if (event.key === 'Escape') close();
      });
      document.addEventListener('mousedown', function (event) {
        if (!root.contains(event.target)) close();
      });
    });
  }

  bindNavDropdowns();

  (function stickyMobileHeader() {
    if (window.__lsbStickyHeader) return;
    window.__lsbStickyHeader = true;

    var header = document.querySelector('.header');
    if (!header) return;

    var mq = window.matchMedia('(max-width: 63.99em)');
    var ticking = false;

    function apply() {
      ticking = false;
      if (!mq.matches) {
        header.classList.remove('is-stuck');
        return;
      }
      var y = window.scrollY || window.pageYOffset || 0;
      if (y > 64) header.classList.add('is-stuck');
      else if (y < 24) header.classList.remove('is-stuck');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyWindow(root) {
      var cards = root.querySelectorAll('[data-upsell-card]');
      var take = Number.parseInt(root.getAttribute('data-take') || '12', 10);
      var interval = Number.parseInt(root.getAttribute('data-interval') || '360000', 10);
      if (cards.length <= take) return;
      var cycle = Math.floor(Date.now() / interval);
      var start = (cycle * take) % cards.length;
      cards.forEach(function (card, index) {
        var offset = (index - start + cards.length) % cards.length;
        card.hidden = offset >= take;
      });
      var track = root.querySelector('[data-rail-track]');
      if (track) track.scrollLeft = 0;
      var rail = root.querySelector('[data-product-rail]');
      if (rail && typeof rail._updateArrows === 'function') rail._updateArrows();
    }

    function schedule(root) {
      applyWindow(root);
      var interval = Number.parseInt(root.getAttribute('data-interval') || '360000', 10);
      var remaining = interval - (Date.now() % interval);
      window.setTimeout(function () {
        applyWindow(root);
        window.setInterval(function () { applyWindow(root); }, interval);
      }, remaining);
    }

    document.querySelectorAll('[data-upsell-rail]').forEach(schedule);
  })();

  } catch(e) { console.error(e); }
})();
})();
